import { useI18n } from 'app/components/localization';
import React, { useState, useEffect } from 'react';
import { OperatingSystem } from '../../../utils/userAgent';
import BrowserSpecific from '../../common/BrowserSpecific';
import CallErrorMessage, { Severity } from './CallErrorMessage';
import { useBookingState } from 'app/containers/rtc/BookingContext/BookingState';
import { useIsWebRTCSupported } from 'app/containers/rtc/BookingContext/useRequiredFeatures';

const UnsupportedErrorMessage = () => {
  const [show, setShow] = useState(false);
  const onABooking = Boolean(useBookingState());
  const { t } = useI18n();
  const isSupported = useIsWebRTCSupported();

  // React to the SetSignalingState: when it becomes ON, show the
  // unsupported message, when it becomes off, hide it
  useEffect(() => {
    if (!isSupported && onABooking) {
      setShow(true);

      return () => {
        setShow(false);
      };
    }
  }, [onABooking, isSupported]);

  if (!show) {
    return null;
  }

  return (
    <CallErrorMessage
      severity={Severity.Info}
      buttonAction={() => setShow(false)}
      buttonLabel={t('forms.dismiss')}
    >
      <BrowserSpecific>{({ os }) =>
        os === OperatingSystem.iOS
          ? t('rtc.errors.ios-support')
          : t('rtc.errors.video-call-not-supported')
      }</BrowserSpecific>
    </CallErrorMessage>
  );
};

export default UnsupportedErrorMessage;
